export enum StepTypes {
  NORMAL = "",
  FYI = "FYI",
  READONLY = "readonly",
  INTERNAL = "internal",
  DOABLE = "doable"
}

export enum DeadlineTypes {
  NODEADLINE = "none",
  HOURS = "hours",
  DAYS = "days"
}
